import AccountLinksMcom from './mcom/AccountLinks';
import AccountLinksBcom from './bcom/AccountLinks';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? AccountLinksBcom : AccountLinksMcom;
